<template>
  <section class="row">
    <div class="col-12 col-lg-9 mx-auto">
      <v-radio
        input-id="option-equipment"
        label="Sélectionnez votre niveau de protection"
        :list="options"
        path="risk.local.equipment"
        module-name="contract"
        getter-name="subscription"
        setter-name="updateSubscription"
        :getter-function="getValue"
        :setter-function="setValue"
        :input-disabled="disabled"
      />
      <div class="d-flex flex-md-row flex-column flex-wrap mb-2 mb-md-4">
        <div
          class="d-flex flex-column col-md-6 col-12"
          :class="{'offset-md-6': formule !== 'IT_ONLY' }"
        >
          <span
            v-for="(perk, index) in perksList"
            :key="perk"
            :class="{ 'text-gray-400' : isPerkIncluded(index, formule) }"
          >
            <font-awesome-icon
              :icon="['fas', isPerkIncluded(index, formule) ? 'times' : 'check' ]"
              :class="`text-${isPerkIncluded(index, formule) ? 'gray-400' : 'blue-500'}`"
            />
            {{ perk }}
          </span>
        </div>
      </div>
    </div>
  </section>
</template>
<script>
import { mapGetters } from 'vuex';

import { get } from 'lodash-es';
import { ui } from '@/mixins';

import Radio from '@/components/common/input/Radio2.vue';

export default {
  name: 'EquipmentModal',
  components: {
    'v-radio': Radio,
  },
  mixins: [ui],
  props: {
    disabled: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      perksList: [
        'Matériel informatique',
        'Matériel professionnel',
      ],
    };
  },
  computed: {
    ...mapGetters({
      contract: 'contract/get',
      equipments: 'rater/equipments',
    }),
    options() {
      return this.equipments.map(({ label: name, code: value }) => ({ name, value }));
    },
    formule() {
      return get(this.contract, 'risk.local.equipment.code', 0);
    },
  },
  methods: {
    setValue({ value }, path) {
      const item = this.equipments.find(({ code }) => code === value);
      return { value: item, path };
    },
    getValue(subscription) {
      return get(subscription, 'risk.local.equipment.code', 0);
    },
    isPerkIncluded(index, formule) {
      return index === 1 && formule === this.equipments[0].code;
    },
  },
};
</script>
